// src/store/actions.js
import Vue from 'vue'
import Resource from 'vue-resource'
import router from '../router'
import { API_AI } from '../config/const'
import { Authentication, Cookie, Bridge, getPlatform, getDevice } from '../utils'

Vue.use(Resource)

// HTTP相关
Vue.http.options.crossOrigin = true;
Vue.http.options.credentials = true;


/**
 * 请求处理
 */
Vue.http.interceptors.push((request, next)=>{
    // 这里对请求体进行处理
    Bridge(function(){
        let appId = 'fKhnk3UwbjhLP5NuFNQm5W'
        let appKey = '9dbe75e0-d10a-55a5-b232-ecd60a9f60be'
        let deviceId = 'FBED7066-9101-40CE-8C4E-EAA22C887346'
        request.headers = request.headers || {}
        request.headers.set('Content-Type', 'application/json')
        request.headers.set('X-Zhao-AppId', appId)
        request.headers.set('X-Zhao-DeviceId', deviceId)
        request.headers.set('X-Zhao-OSInfo', '{"os":"h5"}')
    	request.headers.set('Authorization', Authentication(appId, appKey, deviceId, request.method, request.url.replace(API_AI,'').split('?')[0]))

        next((response) => {
            return response
        });
    },function(bridge){
        bridge.callHandler('getDeviceInfo',{},function(response){
        	if(getDevice('android')){
                response = JSON.parse(response);
            }else{
                response = response;
            }
            request.headers = request.headers || {}
        	request.headers.set('Content-Type', 'application/json')
        	request.headers.set('X-Zhao-AppId', response.appId)
            request.headers.set('X-Zhao-DeviceId', response.deviceId)
            request.headers.set('X-Zhao-OSInfo', response.OSInfo)
            request.headers.set('Authorization', Authentication(response.appId, response.appKey, response.deviceId, request.method, request.url.replace(API_AI,'').split('?')[0]));
            next((response) => {
                if (response.status !== 200) {

                } else {
                    response.data = response.json();
                    if (response.url.indexOf('/wxtoken/getJsSignature') == -1 &&
                        response.data.status && response.data.status != 'SUCCESS') {

                    }
                }
            });
        })

    })
});


/*
* 注册一个获取用户基本加密信息
* */
export const registerBridgeTokenInfo = ({commit},options={}) =>{
  Bridge(function () {
   if(options.successWeb)options.successWeb();
  }, function (bridge) {
    bridge.registerHandler('tokenInfo', function (response) {
      if (typeof response == 'string') {var data = JSON.parse(response);} else {var data = response;}
      if (data) {
        Cookie.set('appId',data.appId);
        Cookie.set('appKey',data.appKey);
        Cookie.set('userId',data.userId);
        Cookie.set('deviceId',data.deviceId);
      }
      if(options.successNative)options.successNative(data);

    });
  });
};







// WEBPACK FOOTER //
// ./src/store/actions.js